/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from 'react';
import lottie from 'lottie-web';
import customStyles from "../../../../assets/styles/customStyles";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { idNamingConversion } from "../../../../helpers/utilities";


export const LottieAnimationHover = React.forwardRef((props, ref) => {
    const { icon, title, href } = props;
    const classes = customStyles();

    useEffect(() => {
        props.aRef.current = lottie.loadAnimation({
            container: ref.current,
            renderer: "svg",
            loop: false,
            autoplay: true,
            animationData: icon
        });

        return () => {
            lottie.destroy();
        };
    }, []);

    return (
        <Link to={href}
        id={idNamingConversion(title, 'dashboard', 'Link')}
            onMouseEnter={() => props.aRef.current?.goToAndPlay(1)}
            className={clsx(classes.disInline, classes.positionRelative, classes.textAlignCenter, classes.dashboardIcon)}>
            <div className={classes.lottieAnimationHover}>
                <div className={classes.lottieAnimationHoverInner} ref={ref}></div>
            </div>
            <span className={clsx(classes.dashicontext, classes.margin10t, classes.bold, classes.color)}>{title}</span>
        </Link>
    )

})